import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { useConsent } from '@/shared/contexts/ConsentContext';

export function CookieConsentBanner() {
  const { status, accept, reject } = useConsent();
  const { t } = useTranslation('legal');

  if (status !== 'pending') return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label={t('banner.ariaLabel')}
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-brand-rule bg-brand-navyDeep/95 backdrop-blur supports-[backdrop-filter]:bg-brand-navyDeep/80"
    >
      <div className="mx-auto flex max-w-[1280px] flex-col gap-4 px-6 py-5 sm:flex-row sm:items-center sm:justify-between lg:px-10">
        <p className="max-w-[64ch] text-[14px] leading-[1.6] text-brand-paper">
          {t('banner.message')}{' '}
          <Link to="/datenschutz" className="underline hover:text-brand-teal">
            {t('banner.readMore')}
          </Link>
          .
        </p>
        <div className="flex flex-col gap-2 sm:flex-row">
          <button
            type="button"
            onClick={reject}
            className="inline-flex h-10 items-center justify-center rounded-sm border border-brand-rule px-4 text-[13px] font-semibold tracking-tight text-brand-paper transition-all hover:border-brand-teal hover:text-brand-teal"
          >
            {t('banner.reject')}
          </button>
          <button
            type="button"
            onClick={accept}
            className="inline-flex h-10 items-center justify-center rounded-sm bg-brand-teal px-4 text-[13px] font-semibold tracking-tight text-brand-navy transition-all hover:bg-brand-tealLight"
          >
            {t('banner.accept')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsentBanner;
